// src/Components/ProtectedRoute.js
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  let user = null;

  try {
    const stored = localStorage.getItem('user');
    user = stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error("Failed to parse user data:", error);
    user = null;
  }

  if (!user || !user.token) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
